/* eslint-disable promise/param-names */
import {AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT} from '../actions/auth'
import Vue from 'vue'
import StorageAuth from '@/store/modules/authComponents/storage'
import HttpClient from '@/api/calls'
import TokenDecoder from './authComponents/tokenDecoder'
import CheckerSession from './authComponents/checker'

const state = {token: StorageAuth.getToken() || '', status: '', hasLoadedOnce: false}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status
}

const prepareParamsRequest = function (user) {
  return {
    client_id: Vue.config.webConfig.auth.client_id,
    client_secret: Vue.config.webConfig.auth.client_secret,
    grant_type: Vue.config.webConfig.auth.grant_type,
    password: user.password,
    username: user.username
  }
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    let dataRequest = prepareParamsRequest(user)
    return new Promise((resolves, rejects) =>
      HttpClient.httpPost('auth.login', dataRequest)
        .then(resp => {
          StorageAuth.saveToken(resp)
          let userData = TokenDecoder.decode(StorageAuth.getToken()).user
          StorageAuth.saveUserData(userData)
          if (CheckerSession.checkCorrectSession(userData) === false) {
            StorageAuth.remove()
            rejects(new Error('Checker error'))
          }
          resolves(resp)
        })
        .catch(err => {
          rejects(err)
        }))
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      StorageAuth.remove()
      window.location.reload()
      resolve()
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = StorageAuth.getToken()
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  },
  ERROR_HTTP: (state, code) => {
    if (StorageAuth.getToken() && code === 401) {
      StorageAuth.remove()
      window.location.reload()
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js